import React, { useState } from 'react';
import axios from 'axios';
import {jwtDecode} from 'jwt-decode'; // Correct import for jwt-decode
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import './Login.css';

function Login({ onLogin }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(''); // State for error messages

    const navigate = useNavigate(); // Initialize navigate function

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission
        try {
            // Make login request to the backend
            const response = await axios.post('https://csypblogbackend.azurewebsites.net/api/login', {
                username,
                password,
            });

            const token = response.token;

            // Save token to localStorage
            localStorage.setItem('jwtToken', token);

            // Decode token to get user details
            const decoded = jwtDecode(token);

            // Trigger the onLogin callback with user details
            onLogin({ username: decoded.username, role: decoded.role });

            // Clear any existing error
            setError('');

            // Redirect to the /add-essay page
            navigate('/add-essay');
        } catch (error) {
            // Handle errors
            console.error('Login error:', error.response?.data || error.message);

            // Display error message to the user
            setError('Invalid username or password. Please try again.');
        }
    };

    return (
        <div className="outer-container">
            <div className="form-container">
                <h2 className="login-heading">Login to the Dark Universe</h2>
                {error && <p className="error-message">{error}</p>} {/* Display error message */}
                <form onSubmit={handleSubmit}>
                    <div>
                        <label className="login-label">Username:</label>
                        <input
                            className="login-input"
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Enter your username..."
                            required
                        />
                    </div>
                    <div>
                        <label className="login-label">Password:</label>
                        <input
                            className="login-input"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password..."
                            required
                        />
                    </div>
                    <button type="submit" className="login-button">
                        Login
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Login;
